import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import JobCard from '../components/JobCard';
import Breadcrumb from '../components/Breadcrumb';
import SEO from '../components/SEO';
import { getJobsByCategory, getCategoryById } from '../data/jobs';
import './CategoryJobsPage.css';

const CategoryJobsPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const jobs = getJobsByCategory(categoryId);
  const category = getCategoryById(categoryId);
  const categoryName = category ? category.name : categoryId;

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://sarkarinaukrirajasthan.com/' },
      { '@type': 'ListItem', position: 2, name: categoryName, item: `https://sarkarinaukrirajasthan.com/category/${categoryId}` },
    ],
  };

  return (
    <div className="category-page">
      <SEO
        title={`${categoryName} 2026`}
        description={`Browse latest ${categoryName} vacancies 2026. Find eligibility, salary, important dates and apply online at Sarkari Naukri Rajasthan.`}
        path={`/category/${categoryId}`}
        structuredData={breadcrumbSchema}
      />
      <Breadcrumb
        items={[
          { label: 'Home', to: '/' },
          { label: categoryName },
        ]}
      />

      <div className="category-page-header">
        <div>
          <h1 className="category-page-title">{categoryName}</h1>
          <p className="category-page-subtitle">
            Found <strong>{jobs.length}</strong> active notification{jobs.length !== 1 ? 's' : ''}
          </p>
        </div>
        <button className="btn-back" onClick={() => navigate('/')}>
          ← Back to Home
        </button>
      </div>

      {jobs.length === 0 ? (
        <div className="no-jobs">
          <span className="no-jobs-icon">🔍</span>
          <p>No active job listings found for this category.</p>
          <button className="btn-back" onClick={() => navigate('/')}>Go Back Home</button>
        </div>
      ) : (
        <div className="jobs-list">
          {jobs.map(job => (
            <JobCard
              key={job.id}
              job={job}
              categoryId={categoryId}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CategoryJobsPage;
